import { render, staticRenderFns } from "./RateiosAtualizarEmMassa.vue?vue&type=template&id=c2516600"
import script from "./RateiosAtualizarEmMassa.vue?vue&type=script&lang=js"
export * from "./RateiosAtualizarEmMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports